import { DataCrafterTemplateColumn } from '..';

/**
 * Request model for creating or updating a DataCrafter output variant.
 * Contains the essential properties needed to define an output variant.
 */
export default class CreateUpdateDataCrafterOutputVariantRequest {
    /** Id of the output variant */
    id?: string;

    /** Name of the output variant */
    name: string;

    /** Condition that determines when this variant should be used */
    condition: string;

    /** Array of template columns for this variant */
    columns: DataCrafterTemplateColumn[];

    /** Whether this is the default variant */
    isDefault: boolean;

    /** Generated code for this variant */
    scriptRefId?: string;

    constructor(
        name: string,
        condition: string,
        columns: DataCrafterTemplateColumn[],
        isDefault: boolean,
        scriptRefId?: string,
        id?: string
    ) {
        this.name = name;
        this.condition = condition;
        this.columns = columns;
        this.isDefault = isDefault;
        this.scriptRefId = scriptRefId;
        this.id = id;
    }
}
